import { useCookies } from 'react-cookie';
import { RawCookieName } from '../constants';
const mkpCartCountCookieName = RawCookieName.CART_COUNT;
const mkpCartIdCookieName = RawCookieName.CART_ID;
export function useUniversalHeaderCart() {
  const [cookies] = useCookies([mkpCartCountCookieName, mkpCartIdCookieName]);
  const mkpCartCount = cookies[mkpCartCountCookieName] && cookies[mkpCartIdCookieName] ? cookies[mkpCartCountCookieName] : 0;
  return {
    url: "/shop/cart",
    count: Number(mkpCartCount)
  };
}